import { lazy } from 'react';

export const ProductsPage = lazy(() => import('./ProductsPage'));
export const AdminProductsPage = lazy(() => import('./AdminProductsPage'));
export const ProductsSettingsPage = lazy(() => import('./ProductsSettingsPage'));
